<template>
	<div>
		<div v-show="isShowFixedTabTxT" class="fixedTab">
			{{fixedTabTxT}}
			<span class="markup">
        		<em><i class="iconcss"></i>标配</em>
        		<em><i class="iconcss"></i>选配</em>
        		<em><i class="iconcss"></i>无</em>
        	</span>
		</div>
		<div class="clearfix carInfo">
			<div class="fl carInfo-img">
				<img :src="carAll.carInfo.logo ? (commmonWebConfig.picHost + carAll.carInfo.logo) : commmonWebConfig.webCommonUtils+'/img/mapply/comparison/logo.png'">
			</div>
			<div class="fl carInfo-info">
				<p class="carInfo-tit">{{carAll.carInfo.name}}</p>
				<p class="carInfo-price">厂商指导价(万)：<span :class="[isZero ? 'gray' : 'red']"> {{carAll.carInfo.cSprice | orString}}</span></p>
				<p @click="newbeginComparison" class="carInfo-model">查看其他车款</p>
			</div>
		</div>	
		<a :href="'groupbuy/grouplist?cityId='+cityId+'&modelId='+$route.query.modelid">
		   <div class="groupwrap clearfix" @click="gotogrouppage" v-show="groupwrap">
					<div class="grouproom clearfix">
						<em class="icon1"></em>
						<em class="icon2"></em>
						<em class="icon3"></em>
						<em class="icon4"></em>
						<em class="icon5"></em>
						 <div class="addgroup">
						 	<div class="carStyle">有拼团活动啦</div>
						 	<div class="grouptip">快去参加>></div>
						 </div>
						 <div class="groupCar"></div>
						 <div class="groupBtn"></div>
					</div> 
			 	</div>
		 </a>
		<div id="carInfo-content" class="carInfo-content">
			<dl v-for="(item,index) in carAll.paramlist">
				<dt class="clearfix">
					<span class="fl carInfo-tit">{{item.title}}</span>
					<span class="markup">
	            		<em><i class="iconcss"></i>标配</em>
	            		<em><i class="iconcss"></i>选配</em>
	            		<em><i class="iconcss"></i>无</em>
	            	</span>
				</dt>
				<!--v-if="indexIn!=1"要求隐藏 数组的0 1 项-->
				<dd class="clearfix" v-for="(itemIn,indexIn) in item.carInfoList"  v-if="indexIn!=0 && indexIn!=1">
					<span class="fl">{{itemIn.title}}</span>
					<span class="fr">
						<span v-if="itemIn.type==1">
							<span class="car-color" v-for="(cItem,idx) in filt(itemIn.value)" :key="idx" :style="{'background': cItem.value}"></span>
						</span>
						<span v-else>{{itemIn.value}}</span>
					</span>
				</dd>
			</dl>
		</div>
		<div @click.stop="IsShowMemuContent()" class="menu">
			<div class="menu-tag"><em></em>目录</div>
			<div v-show="memuContentIsShow" class="memu-content">
				<em class="memu-content-arror"></em>
				<ul id="memu-content-list" class="clearfix memu-content-list">
					<li @click.stop="scrollWinTag(index)" v-for="(item,index) in carAll.paramlist">
						{{item.title}}
					</li>
				</ul>
			</div>
		</div>
		<div @click="gotoComparison()" class="menu-comparison">
			<span class="menu-comparison-txt">对比</br>车型</span>
			<em :class="['menu-comparison-num',{'cur':joinClick}]" v-text="comparisonArr.length < 10 ? comparisonArr.length : ''"></em>
		</div>
		<div class="fixedBtn clearfix">
			<!--<button @click="scanCode" class="saoMiao" v-show="isShowMiao">继续扫描</button>-->
			<button @click="joinComparison" class="joinIn">加入对比</button>
		</div>
	</div>
</template>
<style scoped lang="less">
.car-color{
	display: inline-block;
	margin-left: 0.4rem;
	width: 0.6rem;
	height: 0.5rem;
}
.gray{
	color: #666;
}
</style>
<script>
	import { Toast } from 'mint-ui';
	var VM = '';
	export default {
		name: 'comparison',
		data: function() {
			VM = this;
			return {
				isZero: false,
				//是否展示menu
				memuContentIsShow: false,
				//记录当前滚动距离
				scrollParams: {
					winScrollTop: 0,
					tagOffsetTop: [],
				},
				//跟随的标题
				fixedTabTxT: "",
				isShowFixedTabTxT: false,

				carAll: {
					carInfo: {
						cSprice:''
						// id:0,
						// name:"宝来2019款 1.5L 手自一体 时尚版",
						// logo:"http://pic.tuanche.com/car/20151012/14446420934155159_o.jpg",
						// price:"20.12万－27.12万"
					},
					paramlist: [
						// {
						// 	title:"基本参数",
						// 	carInfoList:[
						// 		{
						// 			title:"厂商指导价",
						// 			value:"12.5万"
						// 		},
						// 		{
						// 			title:"厂商指导价",
						// 			value:"12.5万"
						// 		},
						// 		{
						// 			title:"厂商指导价",
						// 			value:"12.5万",
						// 			type:"special"
						// 		}
						// 	]
						// },
						// {
						// 	title:"基本参数1",
						// 	carInfoList:[
						// 		{
						// 			title:"厂商指导价",
						// 			value:"12.5万"
						// 		},
						// 		{
						// 			title:"厂商指导价",
						// 			value:"12.5万"
						// 		},
						// 		{
						// 			title:"厂商指导价",
						// 			value:"12.5万"
						// 		}
						// 	]
						// },
						// {
						// 	title:"基本参数2",
						// 	carInfoList:[
						// 		{
						// 			title:"厂商指导价",
						// 			value:"12.5万"
						// 		},
						// 		{
						// 			title:"厂商指导价",
						// 			value:"12.5万"
						// 		},
						// 		{
						// 			title:"厂商指导价",
						// 			value:"12.5万"
						// 		}
						// 	]
						// },
						// {
						// 	title:"基本参数3",
						// 	carInfoList:[
						// 		{
						// 			title:"厂商指导价",
						// 			value:"12.5万"
						// 		},
						// 		{
						// 			title:"厂商指导价",
						// 			value:"12.5万"
						// 		},
						// 		{
						// 			title:"厂商指导价",
						// 			value:"12.5万"
						// 		}
						// 	]
						// },
						// {
						// 	title:"基本参数4",
						// 	carInfoList:[
						// 		{
						// 			title:"厂商指导价",
						// 			value:"12.5万"
						// 		},
						// 		{
						// 			title:"厂商指导价",
						// 			value:"12.5万"
						// 		},
						// 		{
						// 			title:"厂商指导价",
						// 			value:"12.5万"
						// 		}
						// 	]
						// },
						// {
						// 	title:"基本参数5",
						// 	carInfoList:[
						// 		{
						// 			title:"厂商指导价",
						// 			value:"12.5万"
						// 		},
						// 		{
						// 			title:"厂商指导价",
						// 			value:"12.5万"
						// 		},
						// 		{
						// 			title:"厂商指导价",
						// 			value:"12.5万"
						// 		}
						// 	]
						// }
					]
				},

				//点击对比车型，动态效果
				joinClick: false,
				comparisonArr: [],
				isShowMiao:false,
				groupwrap:false,
				cityId:''

			}
		},
		mounted: function() {
			var self = this;
			getCommonJsIns.initCSSNEW();
			getCommonJsIns.initSingleCSSNEW({
				cssURL: "/css/mapply/comparison/index.css?v=123sdees3"
			});
			//确保重要依赖的js加载完成
			getCommonJsIns.initJSNEW(this.webReady);
			/***统计添加**/
			! function(e, t, n, g, i) {
				e[i] = e[i] || function() {
					(e[i].q = e[i].q || []).push(arguments)
				};
				var n = t.createElement("script");
				var tag = t.getElementsByTagName("script")[0];
				n.async = 1;
				n.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + g;
				tag.parentNode.insertBefore(n, tag);
			}(window, document, "script", "assets.growingio.com/2.1/gio.js", "gio");
			gio('init', '8004d11f5708cccc', {});
			//custom page code begin here
			//custom page code end here
			gio('send');
			gio('enableHT', 'true');
			/***统计添加**/

		},
		methods: {
			//数组去重
			distinct: function(arr) {
				var result = [],
					i, j, len = arr.length;
				for(i = 0; i < len; i++) {
					for(j = i + 1; j < len; j++) {
						if(arr[i] === arr[j]) {
							j = ++i;
						}
					}
					result.push(arr[i]);
				}
				return result;
			},
			webReady: function() {
				var self = this;
				//点击任意地方关闭目录
				document.getElementById("carInfo-content").onclick = function(event) {
					self.memuContentIsShow = false;
				}
				//初始化页面信息
				this.initWeb();
				this.getCity();	
				// this.isWeiXin();
				// this.saoMiao();
				//初始化页面对比数量
				if(webCommonUtil.commonFun.localStore("comparisonModelId") && webCommonUtil.commonFun.localStore("comparisonModelId") != "") {
					self.comparisonArr = webCommonUtil.commonFun.localStore("comparisonModelId").split(",");
				}

			},
			isWeiXin:function(){    
				  var self=this;
				  var ua = navigator.userAgent.toLowerCase();
			        if (ua.match(/MicroMessenger/i) == "micromessenger") {       
			            console.log('这就是微信内置的浏览器！');
				     	self.isShowMiao=true;
				     	 return true;
			        } else {
			            console.log('这不是通过微信内置浏览器');
				        self.isShowMiao=false;
			            return false;
			        }		  
            },
			filt:function(item){
				if(item!=''){
					return JSON.parse(item);
				}
			},
			initWeb: function() {
				var self = this;
				self.ajaxSubmit.ajax({
					url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.comparisonList,
					type: "get",
					headers: {
						"if-statistical": true
					},
					data: {
						carIds: self.$route.query.modelid
					},
					success: function(data) {
						if(data.responseHeader.status == 200) {
							self.carAll.carInfo = data.response.result[0].carInfo;
							var indexs=0;
							for(var i in data.response.result[0].paramlist) {
								for(var j in data.response.result[0].paramlist[i].carInfoList) {
									if(indexs == 0){
									   self.carAll.carInfo.cSprice=data.response.result[0].paramlist[i].carInfoList[j].value;
									}
									indexs++;
									var curItem = data.response.result[0].paramlist[i].carInfoList[j];
									if(typeof(curItem.schema) == "undefined" && parseInt(curItem.value) == 0) {
										self.$set(data.response.result[0].paramlist[i].carInfoList[j], "value", "-");
									};
									if(typeof(curItem.schema) != "undefined" && curItem.schema == "radio") {
										var type = parseInt(curItem.value);
										switch(type) {
											case 0:
												self.$set(data.response.result[0].paramlist[i].carInfoList[j], "value", "-");
												break;
											case 1:
												self.$set(data.response.result[0].paramlist[i].carInfoList[j], "value", "●");
												break;
											case 2:
												self.$set(data.response.result[0].paramlist[i].carInfoList[j], "value", "○");
												break;
										}
									}
									if(i==14){
										self.$set(data.response.result[0].paramlist[i].carInfoList[j], "type", 1);
									}else{
										self.$set(data.response.result[0].paramlist[i].carInfoList[j], "type", 0);
									}
								}
								self.carAll.paramlist.push(data.response.result[0].paramlist[i])
							}
							console.log(self.carAll);

							//记录所有便签距离页面顶部的距离
							setTimeout(function() {
								self.getTagOffsetTop();
							}, 1000);

							//页面滚动触发
							window.onscroll = function() {
								self.getWinScrollTop();
							}
						}
					},
					error: function() {}
				})
			},
			initComparison: function() {
				var self = this;
				var comparisonModelIdStr = "";
				//console.log(webCommonUtil.commonFun.localStore("comparisonModelId"));
				if(webCommonUtil.commonFun.localStore("comparisonModelId") && webCommonUtil.commonFun.localStore("comparisonModelId") != "") {
					comparisonModelIdStr = webCommonUtil.commonFun.localStore("comparisonModelId") + "," + self.$route.query.modelid;
				} else {
					comparisonModelIdStr = self.$route.query.modelid;
				}
				self.comparisonArr = comparisonModelIdStr.split(",");

				self.comparisonArr = self.distinct(self.comparisonArr);

				//console.log(comparisonModelIdStr);

				webCommonUtil.commonFun.localStore("comparisonModelId", self.comparisonArr.join(","));

			},
			getWinScrollTop: function() {
				this.scrollParams.winScrollTop = $(window).scrollTop();
				for(var i in this.scrollParams.tagOffsetTop) {
					if(this.scrollParams.tagOffsetTop[i] > this.scrollParams.winScrollTop) {
						if(i == 0) {
							this.fixedTabTxT = this.carAll.paramlist[i].title;
						} else {
							this.fixedTabTxT = this.carAll.paramlist[i - 1].title;
						}
						break;
					}
				}
				if((this.scrollParams.winScrollTop - this.scrollParams.tagOffsetTop[0]) > 0) {
					this.isShowFixedTabTxT = true;
				} else {
					this.isShowFixedTabTxT = false;
				}
			},
			//记录所有便签距离页面顶部的距离
			getTagOffsetTop: function() {
				var oCarInfoContent = document.getElementById("carInfo-content");
				var oCarInfoContentDl = oCarInfoContent.getElementsByTagName("dl");
				//console.log(oCarInfoContentDl.length);
				for(var i = 0; i < oCarInfoContentDl.length; i++) {
					this.scrollParams.tagOffsetTop.push(oCarInfoContentDl[i].offsetTop);
				}
				//console.log(this.scrollParams.tagOffsetTop);
			},
			IsShowMemuContent: function() {
				this.memuContentIsShow = true;
			},
			//页面按照点击滚动到锚点
			scrollWinTag: function(index) {
			    var self=this; 
			    self.memuContentIsShow = false;//关闭菜单
				$(window).scrollTop(self.scrollParams.tagOffsetTop[index]);
				
			},
			//添加
			joinComparison: function() {
				var self = this;
				//加入对比的效果
				this.joinClick = true;
				setTimeout(function() {
					self.joinClick = false;
				}, 500)
				if(this.comparisonArr.length >= 30) {
					Toast({
						message: '最多添加30个对比车型',
						position: 'middle', 
						duration: 2000
					});
				} else {
					this.initComparison();
				}
			},
			gotoComparison: function() {
				var self = this;
				//if(this.comparisonArr.length != 0){
				this.$router.push({
					path: '/mapply/comparisonlist',
					query: {
						modelid: self.$route.query.modelid
					}
				})
				//}
			},
			/*****************/
			getCity:function(){//获取城市
				var self=this;		
				self.ajaxSubmit.ajax({
					url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.getLocatingCity,
					type: "post",
					data: {},
					async: false,
					success:function(data){
						if(data.responseHeader.status == 200){
						   self.cityId=data.response.result.id;
						   console.log(self.cityId);	
						   self.groupCount();//拼团数量
						}else{
							console.log('请求失败');
						}
					},error:function(){
						console.log('error');
					}
					
				 });
			},
			groupCount:function(){//拼团数量
				var self=this;	
				 console.log(self.cityId+'22');		
				self.ajaxSubmit.ajax({
					url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.groupCounts+'?cityId='+self.cityId,
					type: "get",
					data: {
						modelId:self.$route.query.modelid,
                        isCurrent:1,
						isNotExactly:1
					},
					async: false,
					success:function(data){
						if(data.responseHeader.status == 200){
							console.log(data);
						   if(data.response.result == 0 ||data.response.result==""){
						   	  self.groupwrap=false;
						   }else{
						   	 self.groupwrap=true;       
						   }
						}else{
							console.log('请求失败');
						}
					},error:function(){
						console.log('error');
					}
					
				 });
				
			},
			gotogrouppage:function(){//拼团入口
//				console.log(8);
//				var self=this;
////				console.log(self.$route.query.modelid);
//window.location.href=self.commmonWebConfig.tuancheurlapi+'/mapply/groupbuy/grouplist?cityId='+self.cityId+'&modelId='+self.$route.query.modelid;
//				
			},
			newbeginComparison: function(){
				var compare= function(x, y) { //比较函数
					if(x.year < y.year) {
						return 1;
					} else if(x.year > y.year) {
						return -1;
					} else {
						return 0;
					}
				}
				var self = this;
				self.ajaxSubmit.ajax({
					url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.comparisonModelList,
					type: "get",
					data: {
						csId:self.$route.query.modelid
//                      carIds: self.$route.query.modelid
					},
					success: function(data) {
						if(data.responseHeader.status == 200) {
							//排序
							var list = data.response.result.group.sort(compare);
							//排序后获取前10条数据
							var str = "";
							var count = 0;
							for(var i = 0; i < list.length; i++) {
								for(var j = 0; j < list[i].list.length; j++) {
									if(count < 10) {
										if(str != "") {
											str = str + ",";
										}
										str = str + list[i].list[j].id;
										count++;
									}
								}
							}
							console.log(str)
							window.location.href = "/mapply/comparisonparameter?carIds=" + str;
						} else {
							console.log('请求失败');
						}

					},
					error: function() {}
				});
			},
			saoMiao: function() {//二维码扫描
				var self = this;
				self.ajaxSubmit.ajax({
					type: "post",
					url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.wechatrAuth,
					data: {
						"url": window.location.href
					},
					async: false,
					success: function(data) {
						wx.config({
							debug: false,
							appId: data.result.appId, // 必填，公众号的唯一标识
							timestamp: data.result.timestamp, // 必填，生成签名的时间戳
							nonceStr: data.result.nonceStr, // 必填，生成签名的随机串
							signature: data.result.signature, // 必填，签名，见附录1
							jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ", "onMenuShareWeibo", "onMenuShareQZone", "scanQRCode"]
							//jsApiList: ["onMenuShareTimeline","onMenuShareAppMessage"]
						});
					},
					error: function(jqXHR, textStatus, errorThrown) {
						console.log("errorConfig");
					}
				})
			},
			scanCode: function() {
				wx.scanQRCode({
					needResult: 1,
					scanType: ["qrCode", "barCode"],
					success: function(res) {
						console.log(res)
						//alert(JSON.stringify(res));
						var result = res.resultStr;
						window.location.href = result;
					},
					fail: function(res) {
						console.log(res)
						//alert(JSON.stringify(res));

					}
				});
			}
		},
		filters:{
			orString: function(val){
				if(val==0||val=='0'){
					VM.isZero = true;
					return '暂无报价';
				}else{
					VM.isZero = false;
					return val;
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/views/comparison/index.vue